import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectValue } from './types/select-types';
import { AdvancedGenericOption, GenericSelectOption, SimpleGenericOption } from '../../../../shared/types/signaturit/shared-types';
import { Observable } from 'rxjs';

@Component({
  selector: 'signaturit-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent {

  @Input() id: string;
  @Input() labelName: string;
  @Input() placeholder: string;
  @Input() data: unknown[];
  @Input() dataKey: string; // Clave principal del selector
  @Input() dataValue: string; // Valor a mostrar del data en el desplegable. Si es vacío, coge por defecto el objeto
  @Input() selectedValue: any;
  @Input() disabled: boolean = false;
  @Input() errorValue: boolean = false;
  @Input() search: boolean = true;
  @Input() required: boolean;
  @Input() multiple: boolean;
  @Input() width: string;
  @Input() hasGroup: boolean;
  @Input() hasMenu: boolean;
  @Input() menuOptions: [{ label: string, value: string }];
  @Input() dataGroupLabel: string;
  @Input() nameForm: string;
  @Input() error?: string;
  @Input() messageError?: string;
  @Output('selectOption') selectOption: EventEmitter<SimpleGenericOption<GenericSelectOption<unknown>>> = new EventEmitter<SimpleGenericOption<GenericSelectOption<unknown>>>();
  @Output('selectOptionTemplate') selectOptionTemplate: EventEmitter<AdvancedGenericOption<unknown>> = new EventEmitter<AdvancedGenericOption<unknown>>();
  @Output('selectOptionWithMenu') selectOptionWithMenu: EventEmitter<any> = new EventEmitter();

  filteredData: Observable<unknown[]>;

  filterContainer: string;

  originalData: unknown[];

  isFiltered: boolean = false;

  currentRow: any;

  menuOptionSelected: any;

  radioSelected: number = 0;

  showError: boolean = false;

  constructor() { }

  onSelectChange(event: SelectValue, input): void {
    this.selectedValue = event.value;
    this.onBlur(input);
  }

  onRadioChange(event: any, radio): void {
    const index = this.selectedValue.findIndex(res => res.idArea == this.currentRow.idArea);
    if (index != -1) {
      this.selectedValue.splice(index, 1);
      this.selectedValue.push({idArea: this.currentRow[this.dataKey], idRole: event.value});
    } else {
      if (!this.multiple) {
        this.selectedValue = this.currentRow[this.dataKey];
      } else {
        this.selectedValue = [...this.selectedValue, this.currentRow[this.dataKey]];
      }
      this.menuOptionSelected = event.value;
      this.selectOptionWithMenu.emit({ key: this.currentRow[this.dataKey], value: this.menuOptionSelected });
    }
    this.onBlur(radio);
  }

  setSelectedRow(row: any): void {
    this.currentRow = row;
    this.radioSelected = 0;
    for ( let i = 0; i < this.selectedValue.length; i++) {
      if (this.selectedValue[i].idArea == this.currentRow.idArea) {
        this.radioSelected = this.selectedValue[i].idRole;
      }
    }
  }

  isRowSelected(row: any): boolean {
    if (this.multiple) {
      return this.selectedValue?.includes(row[this.dataKey]);
    }

    return false;
  }

  filter(): void {
    if (!this.isFiltered) {
      this.originalData = [...this.data];
      this.isFiltered = true;
    }
    this.data = this.originalData.filter(value => value[this.dataValue].toLowerCase().includes(this.filterContainer.toLowerCase()));
  }

  close(): void {
    this.filterContainer = '';
    if (this.originalData) this.data = [...this.originalData];
  }

  onClickOption(event: GenericSelectOption<unknown>): void {
    this.selectOption.emit({ value: event });
    this.selectOptionTemplate.emit({ key: this.nameForm, value: this.selectedValue });
  }

  onBlur(event): void {
    if (event.multiple) {
      this.showError = !event.selectedValue.length && event.selectedValue !== 0 && event.required ? true : false;
    } else {
      this.showError = !event.selectedValue && event.selectedValue !== 0 && event.required ? true : false;
    }
  }
}
